import React, { Fragment, useState, useEffect} from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col } from 'reactstrap';
import { authHeader } from '../../../utils/functions/CoreFunctions';
import { USER_DETAILS_URL } from '../../../utils/APIEndpoints';
import API from '../../../redux/actions/API';
import { getAlertToast, getCountryCode  } from '../../../utils/functions/CustomFunctions';
import Swal from 'sweetalert2';
import defaultAvatar from '../../../assets/images/defaultImages/defaultAvatar.png';
import Loader from '../../loader';

function View(props){
   const { viewToggle, viewModal, userId } = props;
   const [adminData, setAdminData]  = useState({});
   const [loading, setLoading] = useState(false);
 
   //Get Dashboard Data
   const getAdminData = async () => {
    setLoading(true);
    const options = {
        method : 'GET',
        url : USER_DETAILS_URL,
        headers: authHeader(),
        params: {userId}
    };
     try{
       const response = await API(options);
       const {status} = response.data;
       if(status === 'Success')
       {  
           setAdminData(response.data);
       }
       }catch(error){
           if (error.response) {
           let { data } = error.response;
           Swal.fire(getAlertToast('error', data.message ));
           }
       }finally{
           setLoading(false);
       }
   }
 
    //Did Mount
    useEffect(() => {
      getAdminData();
    }, []);  

    const closeBtn = <a className="close" onClick={viewToggle}>&times;</a>;
    return(
        <Fragment>
            <Modal isOpen={viewModal} toggle={viewToggle} style={{maxWidth:'800px'}} backdrop="static" >
                    <ModalHeader toggle={viewToggle} close={closeBtn}>Admin Details</ModalHeader>
                    <ModalBody >
                    {loading ? <Loader/>
                    :
                        <Row>
                        <Col sm="12" md={{ size: 8, offset: 2 }}>

                        <img className="modelUserImg" src={adminData.profileImage || defaultAvatar} />

                        <div className="kt-widget__content">
                        <div className="kt-widget__info mb-2"><span className="kt-widget__label"> First Name:</span><a href="#" className="kt-widget__data">{adminData.firstName}</a></div>
                        <div className="kt-widget__info mb-2"><span className="kt-widget__label">Last Name: </span><a href="#" className="kt-widget__data">{adminData.lastName}</a></div>
                        <div className="kt-widget__info mb-2"><span className="kt-widget__label">Email:</span><a href="#" className="kt-widget__data">{adminData.email}</a></div>
                        <div className="kt-widget__info mb-2"><span className="kt-widget__label">Phone Number:</span><a href="#" className="kt-widget__data">{getCountryCode()}{adminData.phoneNumber}</a></div>
                        <div className="kt-widget__info mb-2"><span className="kt-widget__label">Address:</span><span className="kt-widget__data">{adminData.address}</span></div>
                        </div>
                        </Col>
                        </Row>
                    }
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={viewToggle}>Close</Button>
                    </ModalFooter>
            </Modal>
        </Fragment>
    );
}

export default View;